import { render, staticRenderFns } from "./ButtonLeakage.vue?vue&type=template&id=36de45d2"
import script from "./ButtonLeakage.vue?vue&type=script&lang=js"
export * from "./ButtonLeakage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports